package one.healthium.cali

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ifaandroid.apps.cali.composeapp.generated.resources.Res
import ifaandroid.apps.cali.composeapp.generated.resources.img_log_water_footer
import ifaandroid.apps.cali.composeapp.generated.resources.paytoneone_regular
import one.healthium.ui.compose.components.AppTopBarStyle
import one.healthium.ui.compose.theme.AppTextStyle
import one.healthium.ui.compose.theme.AppThemeBase
import one.healthium.ui.compose.theme.Colors
import one.healthium.ui.compose.theme.Shapes
import one.healthium.ui.compose.theme.black50
import one.healthium.ui.compose.theme.black_6
import one.healthium.ui.compose.theme.gray_19
import one.healthium.ui.compose.theme.styles.AppButtonStyleRef
import one.healthium.ui.compose.theme.styles.AppNavigationBarStyle
import one.healthium.ui.compose.theme.styles.AppNavigationRailStyle
import one.healthium.ui.compose.theme.styles.ChartStyle
import one.healthium.ui.compose.theme.styles.ContentCardStyle
import one.healthium.ui.compose.theme.styles.DailyTaskItemStyle
import one.healthium.ui.compose.theme.styles.DailyTaskStyle
import one.healthium.ui.compose.theme.styles.HealthKitBannerStyle
import one.healthium.ui.compose.theme.styles.LogControlStyle
import one.healthium.ui.compose.theme.styles.LogWaterControlStyle
import one.healthium.ui.compose.theme.styles.LogWeightControlStyle
import one.healthium.ui.compose.theme.styles.ProfileStyle
import one.healthium.ui.compose.theme.styles.TutorialStyle
import one.healthium.ui.compose.theme.white
import org.jetbrains.compose.resources.Font

@Composable
fun cali() = AppThemeBase(
    colors = Colors.cali,
    shapes = Shapes.cali,
    textStyles = AppTextStyle(
        fontFamily = null,
        fontFamilySecondary = null,
        textField = TextStyle(
            fontSize = 38.sp,
            fontWeight = FontWeight.Light,
        ),
        button = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 16.sp,
            letterSpacing = -(0.16).sp,
        ),
        section = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 17.sp,
        ),
        sectionSmall = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 17.sp,
        ),
    ),
    navigationBarStyle = AppNavigationBarStyle(
        containerColor = Colors.cali.primary,
        defaultLabelColor = Colors.cali.onPrimary.copy(alpha = 0.65f),
        activeLabelColor = Colors.cali.onPrimary,
    ),
    appTopBarStyle = AppTopBarStyle(
        style = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 17.sp,
        )
    ),
    contentCardStyle = ContentCardStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 20.sp,
        ),
    ),
    logWaterControlStyle = LogWaterControlStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
        saveButtonStyleRef = AppButtonStyleRef.Primary,
        progressColor = Colors.cali.onPrimary,
        footerImage = Res.drawable.img_log_water_footer,
    ),
    logWeightControlStyle = LogWeightControlStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
    ),
    logControlStyle = LogControlStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
    ),
    profileStyle = ProfileStyle(
        weightProgressBarStyle = ChartStyle(
            barColor = gray_19,
            highlightedBarColor = Colors.cali.onPrimary,
        ),
        weightProgressChartStyle = ChartStyle(
            barColor = gray_19,
            highlightedBarColor = Colors.cali.primary,
        ),
        caloriesChartStyle = ChartStyle(
            barColor = gray_19,
            highlightedBarColor = Colors.cali.primary,
        ),
    ),
    tutorialStyle = TutorialStyle(
        titleStyle = TextStyle(
            fontFamily = PaytoneOneFontFamily,
            fontSize = 30.sp,
            letterSpacing = -(0.6).sp,
        ),
        messageStyle = TextStyle(
            fontSize = 18.sp,
            lineHeight = 24.sp,
        ),
    ),
    dailyTasksStyle = DailyTaskStyle(
        progressBarColor = Colors.cali.onPrimary,
        progressBarTrackColor = Colors.cali.onPrimary.copy(alpha = 0.15f),
        itemStyle = DailyTaskItemStyle.V2(
            iconTint = black50,
        )
    ),
    healthKitBannerStyle = HealthKitBannerStyle(
        containerColor = black_6,
        contentColor = white,
        shape = RoundedCornerShape(24.dp),
    ),
    navigationRailStyle = AppNavigationRailStyle(
        containerColor = Colors.cali.primary,
        defaultLabelColor = Colors.cali.onPrimary.copy(alpha = 0.65f),
        activeLabelColor = Colors.cali.onPrimary,
    )
)

@Suppress("UnusedReceiverParameter")
internal val AppTextStyle.paytone_16
    @Composable get() = TextStyle(
        fontFamily = PaytoneOneFontFamily,
        fontSize = 16.sp,
    )

@Suppress("UnusedReceiverParameter")
internal val AppTextStyle.paytone_18
    @Composable get() = TextStyle(
        fontFamily = PaytoneOneFontFamily,
        fontSize = 18.sp,
        letterSpacing = -(0.36).sp,
    )

@Suppress("UnusedReceiverParameter")
internal val AppTextStyle.paytone_28
    @Composable get() = TextStyle(
        fontFamily = PaytoneOneFontFamily,
        fontSize = 28.sp,
    )


private val PaytoneOneFontFamily
    @Composable get() = FontFamily(
        Font(Res.font.paytoneone_regular, FontWeight.Normal),
    )
